<template>
    <textarea class="form-control" ref="el"
              :value="value"
              :required="options.required"
              @input="$emit('input', $event.target.value)"
              @click="$emit('click', $event.target.value)"
              @focus="$emit('focus', $event.target.value)"
              @blur="blurHandler"
              @keyup.ctrl.enter="$emit('enter')"
              @invalid.prevent="invalidHandler"
              :rows="getRows">
    </textarea>
</template>

<script>
    export default {
        name: 'textarea-field',
        props: {
            options: {
                type: Object,
                default: () => {return {}}
            },
            value: String,

        },
        computed: {
            getRows() {
                return this.options.rows ? this.options.rows : 1
            }
        },
        methods: {
            blurHandler(e) {
                this.$emit('blur');
                if (!e.target.checkValidity()) {
                    this.$emit('error', e.target.validationMessage);
                }
            },
            invalidHandler(e) {
                this.$emit('invalid', e.target.validationMessage);
            }
        },
        mounted() {
            if (this.options.focusOnMount) {
                this.$refs.el.focus();
            }

        }

    }
</script>


<style scoped>

</style>
